import React, { useCallback, useState } from 'react';
import Image from '../Image';
import LeftArrow from './leftArrow';
import RightArrow from './rightArrow';
import './ImageSlider.css';

// eslint-disable-next-line react/prop-types
const ImageSlider = ({ images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleNext = useCallback(() => {
    if (currentImageIndex === images.length - 1) {
      setCurrentImageIndex(0);
    } else {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  }, [currentImageIndex, images.length]);

  const handlePrev = useCallback(() => {
    if (currentImageIndex === 0) {
      setCurrentImageIndex(images.length - 1);
    } else {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  }, [currentImageIndex, images.length]);

  return (
    <div className="image-slider">
      <div className="slider-image-container">
        <Image src={images[currentImageIndex]} />
      </div>
      <div className="slider-nav-container">
        <div className="slider-nav-left" onClick={handlePrev}>
          <LeftArrow />
        </div>
        <div className="slider-nav-right" onClick={handleNext}>
          <RightArrow />
        </div>
      </div>
      <div className="line-slider">
        <div className="line-container">
          {images.map((image, index) => (
            <div
              key={index}
              className={`line ${
                index === currentImageIndex ? 'selected' : ''
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageSlider;
